import { SVGIcon } from '@shared/Frontend/utils/svg'
import React from 'react'
import { SiteBannerView } from '../../../libraries/siteBanner/siteBanner.template'

export const SiteBanner: SiteBannerView['SiteBanner'] = ({ content, close }) => (
  <div
    className="banner"
    id="site-banner" /*id is used in SSR backend to find the banner in the server side rendered HTML*/
  >
    <div className="banner__inner ls-container ls-gutter">
      <div className="banner__text text--styled" dangerouslySetInnerHTML={{ __html: content }}></div>

      <button className="banner__button button button--icon" onClick={close}>
        <span className="sr-text">Close banner</span>
        <SVGIcon className="button__icon" id="icon-cross" size={14} />
      </button>
    </div>
  </div>
)
